module.exports = __webpack_public_path__ + "img/no-specialist-avatar.12bf670.png?v=1750755973023";